import type { ILocation } from '../types';


export function getLocationInfo(): ILocation {
  return {
    fa: Intl.DateTimeFormat().resolvedOptions().timeZone,
    fb: new Date().getTimezoneOffset(),
  }
}
